<template>
  <div class="bg-[#181E29] w-full h-full">
    <div class="w-full h-full" v-if="channel.playerOnline">
      <iframe
        :src="`https://www.m3u8player.online/embed/m3u8?url=${channel.m3u8}`"
        width="100%"
        height="100%"
        style="border: none; aspect-ratio: 16/9"
        allowfullscreen
      ></iframe>
    </div>
    <div class="w-full h-full" v-else>
      <div class="hidden sm:flex w-full h-full items-center justify-center">
        <video
          id="my-video"
          class="video-js vjs-default-skin w-full h-full object-contain"
          controls
        >
          <source :src="channel.m3u8" type="application/x-mpegURL" />
        </video>
      </div>
      <div
        class="flex sm:hidden w-full h-full items-center justify-center flex-col text-center"
      >
        <div class="w-[50vh]">
          <img
            class="w-full h-full object-contain"
            src="@/assets/images/all/rotateScreen.png"
            alt=""
          />
        </div>
        <div class="text-3xl font-bold">
          Veuillez tourner l'écran <br />
          en mode paysage
        </div>
      </div>
    </div>
    <!-- <input type="range" ref="customVolume" min="0" max="1" step="0.01" /> -->
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import '@videojs/http-streaming'

const CustomButton = videojs.getComponent('Button')

class ChannelListButton extends CustomButton {
  constructor(player, options) {
    super(player, options)
    this.controlText('Liste des chaines') // Texte affiché en accessibilité
    this.addClass('vjs-my-button') // Ajoute une classe CSS
    const icon = document.createElement('div')
    icon.classList.add('flex')
    icon.classList.add('w-[2.2rem]')
    icon.classList.add('h-[2.2rem]')
    icon.classList.add('tvIcon')
    icon.classList.add('mx-auto')
    this.el().appendChild(icon)
  }

  handleClick() {
    this.player().trigger('channelListRequested') // Émet un événement personnalisé
  }
}

// 2️⃣ Enregistrer le bouton pour qu'il soit reconnu par Video.js
videojs.registerComponent('ChannelListButton', ChannelListButton)

export default defineComponent({
  name: 'TvList',
  components: {},
  props: {
    channel: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      eventsIds: [],
      player: null,
    }
  },
  mounted() {
    this.play()
  },
  beforeUnmount() {
    this.destroyPlayer()
  },
  methods: {
    play() {
      if(this.channel.playerOnline) return
      const player = videojs('my-video', {
        controls: true,
        autoplay: false,
        preload: 'auto',
        controlBar: {
          volumePanel: {
            inline: true, // ⬅️ Affiche le contrôle du volume en mode déroulant
          },
        },
      })
      player.ready(() => {
        console.log('mano')
        const channelListButton = player.addChild('ChannelListButton', {})
        player.controlBar.addChild(channelListButton, {}, 0)

        player.on('channelListRequested', () => {
          this.$emit('channelListRequested')
        })
      })

      this.player = player

      player.src({
        src: this.channel.m3u8,
        type: 'application/x-mpegURL',
      })

      player.play()
    },
    destroyPlayer() {
      if(!this.player) return
      this.player?.dispose()
    },
  },
  computed: {},
})
</script>

<style>
.vjs-my-button {
  @apply bg-blue-500 text-white px-3 py-1 rounded-md text-sm font-semibold cursor-pointer;
}

.vjs-my-button:hover {
  @apply bg-blue-600;
}
.vjs-fullscreen-control {
  display: none !important;
}

/* Masquer le bouton PiP (Picture-in-Picture) */
.vjs-picture-in-picture-control {
  display: none !important;
}
.video-js {
  background-color: #242c3b !important; /* Remplace le noir par une couleur personnalisée */
}
.tvIcon {
  background-image: url(/images/tvs/tvIcon.png);
  background-size: 100% 100%;
}
</style>
